import { Link } from 'react-router-dom';
import Arrow from '../../components/ui/Arrow';
import { localizedPath, useLocale, useMessages } from '../../i18n/locale';

export default function NotFoundPage() {
  const locale = useLocale();
  const messages = useMessages();
  const copy = messages.notFound;
  return (
    <main className="module-page">
      <section className="module-hero module-hero--contact">
        <div className="container module-hero__inner">
          <div className="module-hero__copy">
            <div className="module-breadcrumb">
              <Link to={localizedPath(locale)}>{messages.modulePage.home}</Link>
              <span>/</span>
              <span>{copy.name}</span>
            </div>
            <div className="module-eyebrow">
              <span className="module-eyebrow__dot" /> {copy.eyebrow}
            </div>
            <h1>
              <span>{copy.title[0]}</span>
              <span className="module-hero__muted">{copy.title[1]}</span>
            </h1>
            <p>{copy.description}</p>
            <div className="module-hero__actions">
              <Link className="button button--primary" to={localizedPath(locale)}>
                {messages.modulePage.backHome} <Arrow up />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
